import 'magnific-popup'

$(function() {
  $('.js-loginModalBtn').magnificPopup({
    type: 'inline',
    showCloseBtn: false,
    preloader: false,
    closeOnBgClick: false,
    fixedContentPos: true,
    enableEscapeKey: false,
    callbacks: {
      open: function(){
        $('body').css('overflow','hidden');
        $('body').css('height','100%');
        $('html').css('height','100%');
      },
      close: function(){
        $('body').css('overflow','auto');
        $('body').css('height','auto');
        $('html').css('height','auto');
      }
    }
  });

  $(document).on('click touchend','.js-loginModalClose',  function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});